export function datalayerEvent(
    {
        event,
        products = [],
        total,
        tax = null,
        shipping = null,
        coupon = null,
        currency = 'GBP',
        item_list_id = null,
        item_list_name = null,
        onComplete = null,
        eventTimeout = 1000,
    }
) {

    // Exit early if dataLayer is not defined
    if (typeof window.dataLayer === 'undefined') {
        // If GTM isn't available but we have a callback, still execute it
        if (onComplete) onComplete();
        return;
    }

    window.dataLayer.push({ ecommerce: null });

    const ecommerce = {
        currency: currency,
        value: total,
        items: products,
    };

    if (item_list_id) { ecommerce.item_list_id = item_list_id; }
    if (item_list_name) { ecommerce.item_list_name = item_list_name; }

    // (float) Include VAT only if provided.
    if (tax !== null) { ecommerce.tax = tax; }

    // (float) Include shipping only if provided.
    if (shipping !== null) { ecommerce.shipping = shipping; }

    // (string) Include coupon only if provided.
    if (coupon) { ecommerce.coupon = coupon; }

    // Build the push payload
    const payload = { event, ecommerce };

    // Define callbacks for push complete.
    if (onComplete) {
        payload.eventCallback = onComplete;
        payload.eventTimeout = eventTimeout;
    }

    // Push the ecommerce object to the dataLayer
    window.dataLayer.push(payload);
}
